/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    export interface IConfirmModalScope extends ng.IScope {
        name: string;
        title: string;
        description: string;
        type: string;
        modalClose: () => void;
        modalSave: () => void;
    }
    
    /**
     * ConfirmModalController class
     */
    export class ConfirmModalController {
        public static templateURL: string = "decorators/modals/confirm-modal.html";
        public static ID: string = "#id-confirm-modal";
        public static $name: string = "confirmModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', '$sce', 'title', 'description', 'name', 'type'];

        private $scope: IConfirmModalScope;
        private close: (parameters: boolean) => void;

        /**
         * Constructor
         */
        constructor($scope: IConfirmModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    $sce: ng.ISCEService,
                    title: string,
                    description: string,
                    name: string,
                    type: string) {
            this.$scope = $scope;
            this.$scope.description = $sce.trustAsHtml(description);
            this.$scope.title = title;
            this.$scope.name = name;
            this.$scope.type = type;

            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            
            this.close = close;
            
            this.$scope.modalClose = (): void => {
                this.close(false);
            };
            
            this.$scope.modalSave = (): void => {
                this.close(true);
            };
        }
    }
}
